import { Direction } from "@angular/cdk/bidi";
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, Output, TemplateRef } from "@angular/core";

import { CompatibleValue } from "ng-zorro-antd/core/time";
import { FunctionProp } from "ng-zorro-antd/core/types";

import { ɵDateRangePopupComponent as DateRangePopupComponent } from "ng-zorro-antd/date-picker";
import {
  UiCalendarInterface,
  UiCompatibleDate,
  UiDateMode,
  UiDisabledDateFn,
  UiDisabledTimeFn,
  UiPresetRanges,
  UiSupportTimeOptions,
} from "@webapp/ui/date-picker/date-picker.models";
import { UiDatePickerService } from "@webapp/ui/date-picker/services/date-picker.service";

@Component({
  selector: "ui-date-range-popup",
  exportAs: "uiDateRangePopup",
  templateUrl: "date-range-popup.component.html",
})
export class UiDateRangePopupComponent extends DateRangePopupComponent {
  @Input("uiIsRange")
  public isRange!: boolean;
  @Input("uiInline")
  public inline = false;
  @Input("uiShowWeek")
  public showWeek!: boolean;
  @Input("uiLocale")
  public locale!: UiCalendarInterface | undefined;
  @Input("uiDisabledDate")
  public disabledDate?: UiDisabledDateFn;
  @Input("uiDisabledTime")
  public disabledTime?: UiDisabledTimeFn; // This will lead to rebuild time options
  @Input("uiShowToday")
  public showToday!: boolean;
  @Input("uiShowNow")
  public showNow!: boolean;
  @Input("uiShowTime")
  public showTime!: UiSupportTimeOptions | boolean;
  @Input("uiExtraFooter")
  public extraFooter?: TemplateRef<void> | string;
  @Input("uiRanges")
  public ranges?: UiPresetRanges;
  @Input("uiDateRender")
  public dateRender?: string | TemplateRef<Date> | FunctionProp<TemplateRef<Date> | string>;
  @Input("uiPanelMode")
  public panelMode!: UiDateMode | UiDateMode[];
  @Input("uiDefaultPickerValue")
  public defaultPickerValue!: UiCompatibleDate | undefined | null;
  @Input("uiDir")
  public dir: Direction = "ltr";

  @Output("uiPanelModeChange")
  public readonly panelModeChange = new EventEmitter<UiDateMode | UiDateMode[]>();
  @Output("uiCalendarChange")
  public readonly calendarChange = new EventEmitter<CompatibleValue>();
  @Output("uiResultOk")
  public readonly resultOk = new EventEmitter<void>(); // Emitted when done with date selecting

  constructor(public datePickerService: UiDatePickerService, public cdr: ChangeDetectorRef, ngZone: NgZone, host: ElementRef<HTMLElement>) {
    super(datePickerService, cdr, ngZone, host);
  }
}
